import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function WarningIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M30.283 21.914 20.557 4.69a5.308 5.308 0 0 0-1.923-1.966c-2.52-1.488-5.745-.61-7.2 1.966L1.707 21.92A5.46 5.46 0 0 0 1 24.613C1 27.589 3.359 30 6.267 30h19.456c1.885.01 3.632-1.023 4.563-2.699a5.43 5.43 0 0 0-.003-5.387Zm-16.108-9.513c0-.984.78-1.785 1.746-1.785.963 0 1.746.8 1.746 1.785v5.294c0 .988-.783 1.785-1.75 1.785-.962 0-1.742-.797-1.742-1.785v-5.294Zm3.499 11.295c-.003.99-.79 1.791-1.756 1.791-.97 0-1.756-.803-1.753-1.794 0-.991.787-1.792 1.756-1.792.966.003 1.75.8 1.753 1.792v.003Z"
      />
    </BaseIcon>
  );
}
